<head *ngIf="mostrar && mostrar !== undefined && errorMessage === ''">
    <title>MEGA: Mundo Estrella Galicia | Vive la experiencia cervecera</title>
</head>

<ng-container *ngIf="!mostrar && mostrar !== undefined">
    <app-page-not-found></app-page-not-found>
</ng-container>

<ng-container *ngIf="mostrar && mostrar !== undefined && errorMessage !== ''">
    <head>
        <title>Error</title>
    </head>
    <div class="error-container">
        <div class="mensaje-error-container">
            <div class="mensaje-error">{{ errorMessage }}</div>
            <mat-progress-bar mode="indeterminate" class="progress-bar" color="warn"></mat-progress-bar>
        </div>
    </div>
</ng-container>

<ng-container *ngIf="mostrar && mostrar!== undefined && errorMessage === ''">
    <body>
        <div class="content">
            <div class="row1">
                <div class="dispositivo">
                    <div class="beertype-value marginBottomM5">
                        <img *ngIf="tipoCervezaT1 == '1' || tipoCervezaT1 == undefined" 
                        src="assets/images/mega/pegatina-eg.png" 
                        alt="Tipo de cerveza: Estrella Galicia"
                        class="custom1"/>
                        <img *ngIf="tipoCervezaT1  === '2'" 
                        src="assets/images/mega/pegatina-1906.png" 
                        alt="Tipo de cerveza: Estrella Galicia 1906"
                        class="custom1"/>
                    </div>
                    <div id="targetT1" class="custom2"></div>
                    <!--<lib-ngx-liquid-gauge
                        [value]="nivelT1"
                        [minValue]="0"
                        [maxValue]="100"
                        [circleThickness]="0.05"
                        [circleFillGap]="0.08"
                        [circleColor]="'#a3a3a3'"
                        [waveHeight]="0.05"
                        [waveCount]="1"
                        [waveRiseTime]="1500"
                        [waveAnimateTime]="2500"
                        [waveRise]="true"
                        [waveHeightScaling]="true"
                        [waveAnimate]="true"
                        [waveColor]="'rgb(247, 158, 43)'"
                        [waveOffset]="0"
                        [textVertPosition]=".5"
                        [textSize]="1"
                        [valueCountUp]="true"
                        [displayPercent]="true"
                        [textColor]="'#ffffff'"
                        [waveTextColor]="'#ffffff'">
                    </lib-ngx-liquid-gauge>-->
                    <div class="litros-available">
                        <p>Volumen: {{soloDosDecimalesConComa(nvlT1)}} - de {{soloDosDecimalesConString(capacidadT1)}} Litros</p>
                    </div>
                    <div class="extra-container">
                        <div class="extra1">
                            <div class="firts">
                                <div class="value" id="t6">{{soloDosDecimalesConString(temperaturaT1)}}</div>
                                <div class="units">ºC</div>
                            </div>
                        </div>
                        <div class="extra2">
                            <div class="last">
                                <div class="value" id="p6">{{soloDosDecimalesConString(presionT1)}}</div>
                                <div class="units">Bar</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="dispositivo">
                    <div class="beertype-value marginBottomM5">
                        <img *ngIf="tipoCervezaT2 == '1' || tipoCervezaT2 == undefined" 
                        src="assets/images/mega/pegatina-eg.png" 
                        alt="Tipo de cerveza: Estrella Galicia"
                        class="custom1"/>
                        <img *ngIf="tipoCervezaT2  === '2'" 
                        src="assets/images/mega/pegatina-1906.png" 
                        alt="Tipo de cerveza: Estrella Galicia 1906"
                        class="custom1"/>
                    </div>

                    <div id="targetT2" class="custom3"></div>
                    <!--<lib-ngx-liquid-gauge
                        [value]="nivelT2"
                        [minValue]="0"
                        [maxValue]="100"
                        [circleThickness]="0.05"
                        [circleFillGap]="0.08"
                        [circleColor]="'#a3a3a3'"
                        [waveHeight]="0.05"
                        [waveCount]="1"
                        [waveRiseTime]="1500"
                        [waveAnimateTime]="2500"
                        [waveRise]="true"
                        [waveHeightScaling]="true"
                        [waveAnimate]="true"
                        [waveColor]="'rgb(247, 158, 43)'"
                        [waveOffset]="0"
                        [textVertPosition]=".5"
                        [textSize]="1"
                        [valueCountUp]="true"
                        [displayPercent]="true"
                        [textColor]="'#ffffff'"
                        [waveTextColor]="'#ffffff'">
                    </lib-ngx-liquid-gauge>-->

                    <div class="litros-available">
                        <p>Volumen: {{soloDosDecimalesConComa(nvlT2)}} - de {{soloDosDecimalesConString(capacidadT2)}} Litros</p>
                    </div>

                    <div class="extra-container">
                        <div class="extra1">
                            <div class="firts">
                                <div class="value" id="t6">{{soloDosDecimalesConString(temperaturaT2)}}</div>
                                <div class="units">ºC</div>
                            </div>
                        </div>
                        <div class="extra2">
                            <div class="last">
                                <div class="value" id="p6">{{soloDosDecimalesConString(presionT2)}}</div>
                                <div class="units">Bar</div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="dispositivo">
                    <div class="beertype-value marginBottomM5">
                        <img *ngIf="tipoCervezaT3 == '1' || tipoCervezaT3 == undefined" 
                        src="assets/images/mega/pegatina-eg.png" 
                        alt="Tipo de cerveza: Estrella Galicia"
                        class="custom1"/>
                        <img *ngIf="tipoCervezaT3  === '2'" 
                        src="assets/images/mega/pegatina-1906.png" 
                        alt="Tipo de cerveza: Estrella Galicia 1906"
                        class="custom1"/>
                    </div>

                    <div id="targetT3" class="custom3"></div>

                    <div class="litros-available">
                        <p>Volumen: {{soloDosDecimalesConComa(nvlT3)}} - de {{soloDosDecimalesConString(capacidadT3)}} Litros</p>
                    </div>

                    <div class="extra-container">
                        <div class="extra1">
                            <div class="firts">
                                <div class="value" id="t6">{{soloDosDecimalesConString(temperaturaT3)}}</div>
                                <div class="units">ºC</div>
                            </div>
                        </div>
                        <div class="extra2">
                            <div class="last">
                                <div class="value" id="p6">{{soloDosDecimalesConString(presionT3)}}</div>
                                <div class="units">Bar</div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="dispositivo">
                    <div class="beertype-value marginBottomM5">
                        <img *ngIf="tipoCervezaT4 == '1' || tipoCervezaT4 == undefined" 
                        src="assets/images/mega/pegatina-eg.png" 
                        alt="Tipo de cerveza: Estrella Galicia"
                        class="custom1"/>
                        <img *ngIf="tipoCervezaT4  === '2'" 
                        src="assets/images/mega/pegatina-1906.png" 
                        alt="Tipo de cerveza: Estrella Galicia 1906"
                        class="custom1"/>
                    </div>

                    <div id="targetT4" class="custom3"></div>

                    <div class="litros-available">
                        <p>Volumen: {{soloDosDecimalesConComa(nvlT4)}} - de {{soloDosDecimalesConString(capacidadT4)}} Litros</p>
                    </div>

                    <div class="extra-container">
                        <div class="extra1">
                            <div class="firts">
                                <div class="value" id="t6">{{soloDosDecimalesConString(temperaturaT4)}}</div>
                                <div class="units">ºC</div>
                            </div>
                        </div>
                        <div class="extra2">
                            <div class="last">
                                <div class="value" id="p6">{{soloDosDecimalesConString(presionT4)}}</div>
                                <div class="units">Bar</div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="dispositivo">
                    <div class="beertype-value marginBottomM5">
                        <img *ngIf="tipoCervezaT5 == '1' || tipoCervezaT5 == undefined" 
                        src="assets/images/mega/pegatina-eg.png" 
                        alt="Tipo de cerveza: Estrella Galicia"
                        class="custom1"/>
                        <img *ngIf="tipoCervezaT5  === '2'" 
                        src="assets/images/mega/pegatina-1906.png" 
                        alt="Tipo de cerveza: Estrella Galicia 1906"
                        class="custom1"/>
                    </div>

                    <div id="targetT5" class="custom3"></div>

                    <div class="litros-available">
                        <p>Volumen: {{soloDosDecimalesConComa(nvlT5)}} - de {{soloDosDecimalesConString(capacidadT5)}} Litros</p>
                    </div>

                    <div class="extra-container">
                        <div class="extra1">
                            <div class="firts">
                                <div class="value" id="t6">{{soloDosDecimalesConString(temperaturaT5)}}</div>
                                <div class="units">ºC</div>
                            </div>
                        </div>
                        <div class="extra2">
                            <div class="last">
                                <div class="value" id="p6">{{soloDosDecimalesConString(presionT5)}}</div>
                                <div class="units">Bar</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row2">
                <div class="logo marginTop40">
                    <img src="assets/images/mega/logo-mega.png" alt="" class="logo-row2"><br/>
                </div>

                <div class="dispositivo marginTop1P">
                    <div class="beertype-value marginBottomM5">
                        <img *ngIf="tipoCervezaT6 == '1' || tipoCervezaT6 == undefined" 
                        src="assets/images/mega/pegatina-eg.png" 
                        alt="Tipo de cerveza: Estrella Galicia"
                        class="custom1"/>
                        <img *ngIf="tipoCervezaT6  === '2'" 
                        src="assets/images/mega/pegatina-1906.png" 
                        alt="Tipo de cerveza: Estrella Galicia 1906"
                        class="custom1"/>
                    </div>

                    <div id="targetT6" class="custom3"></div>

                    <div class="litros-available">
                        <p>Volumen: {{soloDosDecimalesConComa(nvlT6)}} - de {{soloDosDecimalesConString(capacidadT6)}} Litros</p>
                    </div>

                    <div class="extra-container custom4"> 
                        <div class="extra1">
                            <div class="firts">
                                <div class="value" id="t6">{{soloDosDecimalesConString(temperaturaT6)}}</div>
                                <div class="units">ºC</div>
                            </div>
                        </div>
                        <div class="extra2">
                            <div class="last">
                                <div class="value" id="p6">{{soloDosDecimalesConString(presionT6)}}</div>
                                <div class="units">Bar</div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="dispositivo marginTop1P">
                    <div class="beertype-value marginBottomM5">
                        <img *ngIf="tipoCervezaT7 == '1' || tipoCervezaT7 == undefined" 
                        src="assets/images/mega/pegatina-eg.png" 
                        alt="Tipo de cerveza: Estrella Galicia"
                        class="custom1"/>
                        <img *ngIf="tipoCervezaT7  === '2'" 
                        src="assets/images/mega/pegatina-1906.png" 
                        alt="Tipo de cerveza: Estrella Galicia 1906"
                        class="custom1"/>
                    </div>

                    <div id="targetT7" class="custom3"></div>

                    <div class="litros-available">
                        <p>Volumen: {{soloDosDecimalesConComa(nvlT7)}} - de {{soloDosDecimalesConString(capacidadT7)}} Litros</p>
                    </div>

                    <div class="extra-container custom4">
                        <div class="extra1">
                            <div class="firts">
                                <div class="value" id="t6">{{soloDosDecimalesConString(temperaturaT7)}}</div>
                                <div class="units">ºC</div>
                            </div>
                        </div>
                        <div class="extra2">
                            <div class="last">
                                <div class="value" id="p6">{{soloDosDecimalesConString(presionT7)}}</div>
                                <div class="units">Bar</div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="dispositivo marginTop1P">
                    <div class="beertype-value marginBottomM5">
                        <img *ngIf="tipoCervezaT8 == '1' || tipoCervezaT8 == undefined" 
                        src="assets/images/mega/pegatina-eg.png" 
                        alt="Tipo de cerveza: Estrella Galicia"
                        class="custom1"/>
                        <img *ngIf="tipoCervezaT8  === '2'" 
                        src="assets/images/mega/pegatina-1906.png" 
                        alt="Tipo de cerveza: Estrella Galicia 1906"
                        class="custom1"/>
                    </div>

                    <div id="targetT8" class="custom3"></div>

                    <div class="litros-available">
                        <p>Volumen: {{soloDosDecimalesConComa(nvlT8)}} - de {{soloDosDecimalesConString(capacidadT8)}} Litros</p>
                    </div>
                    <div class="extra-container custom4">
                        <div class="extra1">
                            <div class="firts">
                                <div class="value" id="t6">{{soloDosDecimalesConString(temperaturaT8)}}</div>
                                <div class="units">ºC</div>
                            </div>
                        </div>
                        <div class="extra2">
                            <div class="last">
                                <div class="value" id="p6">{{soloDosDecimalesConString(presionT8)}}</div>
                                <div class="units">Bar</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="contador">
                    <div class="contador-header">
                        CONSUMOS DEL DÍA
                    </div>
                    <div class="contadores">
                        <div class="estrella-contador">
                            <img src="assets/images/mega/pegatina-eg-base.png" class="cerveza-etiqueta-contador" alt="">
                            <span class="custom5">{{soloDosDecimalesConComa(consumoLitrosEstrella)}}</span>
                            <span class="custom6">Litros</span>
                        </div>
                        <div class="milnueve-contador">
                            <img src="assets/images/mega/pegatina-1906-base.png" class="cerveza-etiqueta-contador" alt="">
                            <span class="custom7">{{soloDosDecimalesConComa(consumoLitros1906)}}</span>
                            <span class="custom6">Litros</span>
                        </div>
                    </div>
                    <div class="contadores-tiempo">
                        <img src="assets/images/mega/realtime.gif" class="custom8" alt="">
                        <span class="containerNDispositivosHora custom9">{{ time | date: 'HH:mm:ss' }}</span>
                        <span class="custom10">{{formattedDate}}</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="footer">
            <div class="imagen-texto-footer">
                <p><img src="assets/images/mega/logo-eg.png"  alt="Mega Museo Estrella Galicia" class="logo-footer">| Corporación Hijos de Rivera &copy; 2020</p>
            </div>
        </div>
    </body>
</ng-container>


